import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationService } from 'src/app/services/location.service';
import { Location } from 'src/app/models/location';
import { AdminsAndProctorsService } from 'src/app/services/admins-and-proctors.service';
import {
  leadResult,
  people,
  studentAdminResult,
  proctorResult,
} from 'src/app/models/contacts';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss'],
})
export class LocationSearchComponent implements OnInit {
  leadResults!: leadResult;
  studentResults!: studentAdminResult;
  proctorResults!: proctorResult;
  selectedLocation!: Location;
  showHide!: boolean;
  locs$!: Observable<Location[]>;

  /** Done like this to use same component multiple times. Only outputs the cooresponding peopleType.
   * //*Inputs people types to determine which output to return
   */

  @Input() peopleTypes!: number[];
  @Output() leads: EventEmitter<leadResult> = new EventEmitter();
  @Output() studentAdminsOut: EventEmitter<studentAdminResult> =
    new EventEmitter();
  @Output() proctorsOut: EventEmitter<proctorResult> = new EventEmitter();

  httpClient: any;
  constructor(
    public locServ: LocationService,
    private contServ: AdminsAndProctorsService
  ) {}

  ngOnInit() {
    this.locServ.getLocations();
    this.showHide = false;
  }

  setLocation() {
    if (this.selectedLocation) {
      if (this.peopleTypes.includes(people.leadAdmin)) {
        this.contServ.getLeadAdmins2(this.selectedLocation.LocationId);
        this.showHide = true;
        this.leadResults = {
          locationChoice: this.selectedLocation,
          showHide: this.showHide,
        };
        this.leads.emit(this.leadResults);
      }
      if (this.peopleTypes.includes(people.studentAdmin)) {
        this.contServ.getStudentAdmins2(this.selectedLocation.LocationId);
        this.studentResults = {
          locationChoice: this.selectedLocation,
          showHide: this.showHide,
        };
        this.studentAdminsOut.emit(this.studentResults);
      }
      if (this.peopleTypes.includes(people.proctor)) {
        this.contServ.getProctors2(this.selectedLocation.LocationId);
        this.showHide = true;
        this.proctorResults = {
          locationChoice: this.selectedLocation,
          showHide: this.showHide,
        };
        this.proctorsOut.emit(this.proctorResults);
      }
    }
  }
}
